export function firstSectionScrollBottom() {
    $(".scroll-bottom-button").on("click", function (event) {
        event.preventDefault();
        let $this = $(this);
        let scroll;
        scroll = $this.parents(".first-section, .section").innerHeight();
        if ($this.parent(".three-images-hero").length) {
            scroll = $this.parent(".three-images-hero").next().offset().top;
        }
        $('body,html').animate({scrollTop: scroll}, 700);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/firstSectionScrollBottom.js